<h4><b>今個星期</b></h4><br>

<table class="table table-striped table-sm">
    <tbody>
        <tr *ngFor="let mn of money" (click)="clickRow(mn.udate)">
            <td width="60%">{{mn.udate}}</td>
            <td width="40%">${{mn.sum}}</td>
        </tr>
        <tr class="table-warning">
            <td><b class="float-right">總共:</b></td>
            <td><b> ${{sum}}</b> </td>
        </tr>
    </tbody>
</table>